import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconHeartSolid48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="heart">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.49031 8.74329C5.35308 6.05262 8.40214 4 13 4C16.6815 4 19.3106 5.36751 21.2022 7.30059C22.4013 8.52591 23.2883 9.96189 23.9723 11.3744C24.5894 9.97979 25.3805 8.54365 26.5172 7.31955C28.3449 5.35131 30.9923 4 35 4C37.1767 4 40.1633 4.6738 42.6273 6.65875C45.1323 8.67664 47 11.9731 47 17C47 19.2631 46.0851 21.5752 44.6775 23.8403C43.2644 26.1142 41.3033 28.4226 39.092 30.6971C35.8804 34.0004 32.0551 37.3155 28.4927 40.4027C27.1649 41.5534 25.8737 42.6724 24.6644 43.7474C24.2855 44.0842 23.7145 44.0842 23.3356 43.7474C21.7778 42.3627 20.0721 40.9259 18.3236 39.4532C15.1148 36.7504 11.7624 33.9266 8.91789 31.0821C4.54086 26.7051 1 21.9452 1 17C1 14.5975 1.66109 11.3855 3.49031 8.74329Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconHeartSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="heart">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.0321223 8.44649C0.381399 4.85901 2.99105 2 6.50004 2C8.80523 2 10.8454 3.38796 11.9997 5.30047C13.1362 3.4131 15.1476 2.00044 17.5 2.00044C21.0126 2.00044 23.6098 4.7903 23.9647 8.41402C23.9686 8.44081 23.978 8.51258 23.9849 8.59593C23.9953 8.71966 24.0031 8.88786 23.9988 9.0978C23.9903 9.51809 23.9332 10.1026 23.7524 10.8293C23.2476 12.8617 22.0821 14.692 20.4134 16.1274L20.4109 16.1296L12.6496 22.7603C12.2755 23.0799 11.7245 23.0799 11.3504 22.7603L3.59201 16.1313L3.58943 16.1291C1.91814 14.6912 0.753181 12.8615 0.247831 10.8292M0.0321223 8.44649C0.0321223 8.44649 -0.00746475 8.67454 0.00125458 9.09804C0.0098988 9.51789 0.0670277 10.1025 0.247831 10.8292"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.0321223 8.44649C0.381399 4.85901 2.99105 2 6.50004 2C8.80523 2 10.8454 3.38796 11.9997 5.30047C13.1362 3.4131 15.1476 2.00044 17.5 2.00044C21.0126 2.00044 23.6098 4.7903 23.9647 8.41402C23.9686 8.44081 23.978 8.51258 23.9849 8.59593C23.9953 8.71966 24.0031 8.88786 23.9988 9.0978C23.9903 9.51809 23.9332 10.1026 23.7524 10.8293C23.2476 12.8617 22.0821 14.692 20.4134 16.1274L20.4109 16.1296L12.6496 22.7603C12.2755 23.0799 11.7245 23.0799 11.3504 22.7603L3.59201 16.1313L3.58943 16.1291C1.91814 14.6912 0.753181 12.8615 0.247831 10.8292M0.0321223 8.44649C0.0321223 8.44649 -0.00746475 8.67454 0.00125458 9.09804C0.0098988 9.51789 0.0670277 10.1025 0.247831 10.8292"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconHeartSolid16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="heart">
            <path
                d="M15.8414 6.59134C15.5133 7.92929 14.7529 9.14825 13.6445 10.1142L8.32718 14.7167C8.13932 14.8794 7.86055 14.8793 7.6727 14.7167L2.35739 10.1155C1.24698 9.14761 0.486922 7.92897 0.158565 6.59102C-0.0774522 5.62989 0.0198881 5.08343 0.0198881 5.08343C0.23657 2.73625 1.88241 1 3.9999 1C5.56234 1 7 1.5 8 4C9 1.5 10.4005 1.00032 12 1.00032C14.1171 1.00032 15.7587 2.70418 15.9797 5.08182C15.9804 5.08695 16.0774 5.63021 15.8414 6.59134Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
